// import mutations from "@/store/mutations/settingDataMutation";
import getters from "@/store/getters/startUpPolicyGetters";
/**
 * [GX] SETTING DATA
 */
export default {
    state: {
        launchParams: null,
        settingLaunchParams: null,
        defaultLaunchParams: {
            "vip_before_welcome": false,
            "without_welcome": false,
            "vip_plan": "A"
        },
        settingExist: false,
        startSettingExist: false,
        hasRedirect: false,    // 进入app初识的导量
        isRedirect: false   // 是否是导量或者superpay
    },
    // mutations,
    // actions,
    getters
};
